import * as Sentry from '@sentry/vue';
import { Context, CaptureContext } from '@sentry/types';

export function captureMessage(message: string, context?: Context): void {
  Sentry.captureMessage(message, prepareContext(context));
}

export function captureException(e: any, context?: Context) {
  Sentry.captureException(e, prepareContext(context));
}

function prepareContext(context?: Context): CaptureContext {
  const captureContext: CaptureContext = {};
  if (typeof context !== 'undefined') {
    captureContext.contexts = {data: context};
  }

  return captureContext;
}
